import type { TenantRole } from '../types'

export type NavigationCapability = 'campaign.read' | 'campaign.operate' | 'report.read'

export interface NavigationContext {
  role: TenantRole
  capabilities: ReadonlySet<NavigationCapability>
}

export interface NavigationItem {
  id: 'overview' | 'campaigns' | 'operations' | 'reports'
  href: `#${string}`
  labelKey: 'nav.overview' | 'nav.campaigns' | 'nav.creatorOperations' | 'nav.clientDashboard' | 'nav.reports'
  requires?: NavigationCapability
  roles?: readonly TenantRole[]
}

const baseNavigation: readonly NavigationItem[] = [
  { id: 'overview', href: '#overview', labelKey: 'nav.overview' },
  { id: 'campaigns', href: '#campaigns', labelKey: 'nav.campaigns', requires: 'campaign.read' },
  {
    id: 'operations',
    href: '#operations',
    labelKey: 'nav.creatorOperations',
    requires: 'campaign.operate',
    roles: ['system_admin', 'agency_admin', 'operator'],
  },
  {
    id: 'operations',
    href: '#operations',
    labelKey: 'nav.clientDashboard',
    requires: 'campaign.read',
    roles: ['client_viewer'],
  },
  { id: 'reports', href: '#reports', labelKey: 'nav.reports', requires: 'report.read' },
]

export function getNavigation(context: NavigationContext): NavigationItem[] {
  return baseNavigation.filter((item) => {
    if (item.roles && !item.roles.includes(context.role)) return false
    if (item.requires && !context.capabilities.has(item.requires)) return false
    return true
  })
}

export function capabilitiesForRole(role: TenantRole): ReadonlySet<NavigationCapability> {
  if (role === 'client_viewer') return new Set(['campaign.read', 'report.read'])
  return new Set(['campaign.read', 'campaign.operate', 'report.read'])
}
